// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1KcDH","col":"styles_col__39z_Q"};